/*
 * Module for the Contribution Rate Detail's percentage partial view
*/
rs.module("content/system/configuration/contributionrates/detail/percentage",

    ["controls/components/event-banner" ],

    function (eventBanner) {

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl, grid) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var percentUpdateToken = criteria.js(jsSelectors.percentUpdateToken);
            var formContributionRulePercentKey = criteria.js(jsSelectors.contributionRulePercentKey);
            var percentInput = criteria.js(jsSelectors.percentInput);
            var effectiveDateInput = criteria.js(jsSelectors.effectiveDateInput);
            var terminationDateInput = criteria.js(jsSelectors.terminationDateInput);
            var addButton = criteria.js(jsSelectors.addButton);
            var cancelButton = criteria.js(jsSelectors.cancelButton);

            // On the add link button click, clear form
            addButton.click(function () {
                clearBanner();
                grid.selectedValues = null;
                formContributionRulePercentKey.val(-1);
                [
                    percentUpdateToken,
                    percentInput,
                    effectiveDateInput,
                    terminationDateInput
                ].forEach((input) => input.clearErrors().val(''));
            });

            // On the cancel link button click, reset the form
            cancelButton.click(function () {
                grid.selectedValues = null;
                grid.selectFirstRow();
                clearBanner();
            });

            // Listen for row selection 
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {


                    $.getJSON(backendUrl, { contributionRulePercentKey: values[0] }).done(function (data) {

                        formContributionRulePercentKey.val(values[0]);
                        percentUpdateToken.val(data.updateToken);
                        percentInput.val(data.percent);
                        effectiveDateInput.val(data.effectiveDate);
                        terminationDateInput.val(data.terminationDate);

                    });

                    clearBanner();
                }

                _executeSelectionChanged = true;
            });

            // Clear the event banner of all messages.
            function clearBanner() {
                eventBanner.removeErrorMessages();
                eventBanner.removeInformationalMessages();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);